export var authGuard = function (to, from, next) {
    var isAuthenticated = localStorage.getItem('LoggedUser')
    if (isAuthenticated) next();
    else next('/login');
}

// SUPPORT_AGENT uses the same Subscribers/Subscription pages an OPERATOR would (with an
// operator-context selector layered on top, since the agent has no operator of their own) —
// billing, packages, settings, wallet, and operator/config management must stay out of reach
// per REQ-09, regardless of what the backend privilege table allows.
// authGuard only fires when entering /admin from outside it, so this is a separate
// router.beforeEach that re-checks on every navigation, including child-to-child.
var SUPPORT_AGENT_ALLOWED_ROUTES = ['SubscriberManagement', 'SubscriptionManagement', 'SupportTicketManagement', 'UserProfileComponent'];

export var roleGuard = function (to, from, next) {
    var userRole = localStorage.getItem('userRole');
    if (userRole === 'SUPPORT_AGENT' && to.matched.some(r => r.name === 'Application')) {
        if (!SUPPORT_AGENT_ALLOWED_ROUTES.includes(to.name)) {
            return next({ name: 'SubscriberManagement' });
        }
    }
    next();
}
